let disable_button = ($button) => {
    window.Smart.console.log('disable_button', $button);

    if ($button === null) {
        return;
    }

    if ($button.hasClass('disabled')) {
        return;
    }

    let buttonHtml = $button.html();

    $button.attr('disabled', 'disabled');
    $button.addClass('disabled');

    $button.html('<i class="far fa-spin fa-spinner"></i>');

    return buttonHtml;
}

export default disable_button;
